(() => {
  const root = document.querySelector('[data-glamp-ai]');
  if (!root) return;

  const openButton = root.querySelector('[data-glamp-ai-open]');
  const closeButton = root.querySelector('[data-glamp-ai-close]');
  const dialog = root.querySelector('[data-glamp-ai-dialog]');
  const backdrop = root.querySelector('[data-glamp-ai-backdrop]');
  const frame = root.querySelector('.glamp-ai__frame');
  let previousFocus = null;
  let stickySyncFrame = 0;
  let observedStickyBar = null;
  let stickyResizeObserver = null;
  let stickyMutationObserver = null;

  const focusableSelector = 'a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  const syncStickyBarOffset = () => {
    stickySyncFrame = 0;
    const stickyBar = document.querySelector('.product__sticky');

    if (!stickyBar) {
      root.classList.remove('glamp-ai--avoid-sticky');
      root.style.removeProperty('--glamp-ai-sticky-offset');
      root.style.removeProperty('--glamp-ai-sticky-top');
      return;
    }

    if (stickyBar !== observedStickyBar) {
      stickyResizeObserver?.disconnect();
      stickyMutationObserver?.disconnect();
      if ('ResizeObserver' in window) {
        stickyResizeObserver = new ResizeObserver(requestStickyBarSync);
        stickyResizeObserver.observe(stickyBar);
      }
      stickyMutationObserver = new MutationObserver(requestStickyBarSync);
      stickyMutationObserver.observe(stickyBar, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
      });
      observedStickyBar = stickyBar;
    }

    const rect = stickyBar.getBoundingClientRect();
    const style = window.getComputedStyle(stickyBar);
    const isVisible = rect.height > 0
      && rect.top < window.innerHeight
      && rect.bottom > 0
      && style.visibility !== 'hidden'
      && Number.parseFloat(style.opacity || '1') > 0.5;

    if (!isVisible) {
      root.classList.remove('glamp-ai--avoid-sticky');
      root.style.removeProperty('--glamp-ai-sticky-offset');
      root.style.removeProperty('--glamp-ai-sticky-top');
      return;
    }

    const launcherHeight = Math.ceil(openButton.getBoundingClientRect().height || 48);
    const targetTop = Math.max(8, Math.floor(rect.top - launcherHeight - 8));
    root.style.setProperty('--glamp-ai-sticky-top', `${targetTop}px`);
    root.style.removeProperty('--glamp-ai-sticky-offset');
    root.classList.add('glamp-ai--avoid-sticky');
  };

  const requestStickyBarSync = () => {
    if (stickySyncFrame) return;
    stickySyncFrame = window.requestAnimationFrame(syncStickyBarOffset);
  };

  new MutationObserver(requestStickyBarSync).observe(document.body, {
    childList: true,
    subtree: true,
  });
  window.addEventListener('scroll', requestStickyBarSync, { passive: true });
  window.addEventListener('resize', requestStickyBarSync, { passive: true });
  window.visualViewport?.addEventListener('resize', requestStickyBarSync, { passive: true });
  requestStickyBarSync();

  const close = () => {
    dialog.hidden = true;
    backdrop.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('glamp-ai-is-open');
    previousFocus?.focus();
  };

  const open = () => {
    previousFocus = document.activeElement;
    dialog.hidden = false;
    backdrop.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('glamp-ai-is-open');

    if (frame && !frame.src) {
      frame.src = frame.dataset.src;
    }

    closeButton.focus();
  };

  openButton.addEventListener('click', open);
  closeButton.addEventListener('click', close);
  backdrop.addEventListener('click', close);

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll(focusableSelector)];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
